import React from "react";
import ReactDOM from "react-dom";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthLayout from "./common/layouts/Auth";
import AdminLayout from "./common/layouts/Admin";
import UserLayout from "./common/layouts/user";
import AdministratorLayout from "common/layouts/administrator";
import Public from "common/layouts/public";
import { RtlProvider } from "common/components/RTLProvider/RTLProvider";
import { PrivateRoute } from "routes/PrivateRoute";
import { getRole } from "./utils/jwtService";
import { BrowserRouter as Router } from "react-router-dom";
import { roles } from "./common/enums/role";

function App() {
  const role = getRole();
  console.log(role);

  return (
    <div>
      <Router>
        <Routes>
          <Route path={`/landing/*`} element={<Public />} />
          <Route path={`/auth/*`} element={<AuthLayout />} />
          <Route
            path={`/user/*`}
            element={
              <PrivateRoute roles={roles.user}>
                <UserLayout />
              </PrivateRoute>
            }
          />
          <Route
            path={`/admin/*`}
            element={
              <PrivateRoute roles={roles.admin}>
                <AdministratorLayout />
              </PrivateRoute>
            }
          />
          {/* <Redirect from={`/`} to="/administrator/dashboard" /> */}
          {/* <Redirect from={`/`} to="/landing" /> */}
          <Route path="/" element={<Navigate to="/landing/" />} />
          {/* <Route path="*" element={<Navigate to="/landing/" />} /> */}

          {/* </RtlProvider> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
